export const ADD_DASHBOARD_HOLDING_SUMMARY = "ADD_DASHBOARD_HOLDING_SUMMARY";
export const DASHBOARD_HOLDING_START_LOADER = "DASHBOARD_HOLDING_START_LOADER";
export const DASHBOARD_HOLDING_STOP_LOADER = "DASHBOARD_HOLDING_STOP_LOADER";
export const DASHBOARD_HOLDING_ERROR = "DASHBOARD_HOLDING_ERROR";
export const DASHBOARD_HOLDING_HIDE_ERROR = "DASHBOARD_HOLDING_HIDE_ERROR";
